import React from "react";
import AvailableMethodsCon from '$Deposits/Components/Components/AvailableMethods'

class AvailableMethods extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }



    render() {



        return (
            <>
                <AvailableMethodsCon
                    AvailableMethods={(propCon) => {
                        const {
                            methodCode,
                            availableMethods,
                            onChange,
                        } = propCon

                        return (
                            availableMethods.length > 0 ?
                                <>
                                    <p className="inputTitle" data-CN="存款渠道">Cổng Thanh Toán</p>
                                    <div className="methodCodeList">
                                        {
                                            availableMethods.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={methodCode == item.methodCode ? 'methodsListActive' : 'methodsCodeList'}
                                                        onClick={() => { onChange(item.methodCode) }}
                                                    >
                                                        {item.methodType}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </>
                                : <></>
                        )
                    }}

                    CTC={(propCon) => {
                        const {
                            methodCode,
                            availableMethods,
                            onChange,
                        } = propCon
                        const CTCDepositChannels = ["INVOICE","CHANNEL"];
                        return (
                            availableMethods.length > 0 ?
                                <>
                                    <p className="inputTitle" data-CN="存款渠道">Cổng Thanh Toán</p>
                                    <div className="methodCodeList">
                                        {
                                            availableMethods.map((item, index) => {
                                                return (
                                                    <>
                                                        {CTCDepositChannels.some((channel)=>channel === item.methodCode) && 
                                                        <div
                                                            key={index}
                                                            className='methodCodeCTC'
                                                            onClick={() => { onChange(item.methodCode) }}
                                                        >
                                                            <div className="select-box"><div className={methodCode == item.methodCode ? 'activeSelect' : 'borderSelect'} /></div>
                                                            <div className="CTCmethodName">
                                                                <h5 className={methodCode == item.methodCode ? 'CTCActiveColor' : 'CTCColor'}>
                                                                    {
                                                                        item.methodCode === 'CHANNEL' ? `Thanh Toán Nhanh` : 
                                                                        item.methodCode === 'INVOICE' ? 'Thanh Toán Thường' :
                                                                        item.methodType ?? ""
                                                                    }
                                                                </h5>
                                                            </div>
                                                        </div>
                                                        }
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="CTC-tips">
                                        {methodCode == 'CHANNEL' ?'Lệnh gửi tiền chỉ được tạo sau khi hoàn tất các bước gửi tiền.': 'Giải pháp bên thứ ba'}
                                    </div>
                                </>
                                : <></>
                        )
                    }}
                />

            </>
        );
    }
}


export default AvailableMethods



